import { ProductSubtype } from "src/app/ui/models/domains/pbm/Benefit/product-subtype";
import { AbstractParser } from "../../parser";
import { parseProductSubTypes } from "./product-management-parse-funtions";

export class ProductSubTypesParser extends AbstractParser<ProductSubtype[]> {
  public parse(payload: any): ProductSubtype[] {
    return parseProductSubTypes(payload);
  }
}
